var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-guide",style:({left: _vm.pos.x+'px',top:_vm.pos.y+'px'})},[_c('p',[_vm._v("你可以点击这里，切换到不同的课程哦～")]),_c('button',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("我知道了")])])
}
var staticRenderFns = []

export { render, staticRenderFns }